import React, { useState } from "react";
import "animate.css";
import FeatureMedia from "../components/FeatureMedia/FeatureMedia";
import projectFeatured from "../feature.json";

const FeatureProjects = () => {
  const [projectData, setProjectData] = useState(projectFeatured);
  const renderEffect = [
    "zoom",
    "colorful",
    "random",
    "zoom",
    "colorful",
    "random",
  ];

  return (
    <div className={"featureProjectWrapper"}>
      {/*Coming Soon*/}
      <div className="row right animate__animated animate__fadeIn animate__delay-1s">
        <div className="col-md-12">
          <FeatureMedia
            contentPos={"right"}
            opacity={0.3}
            projectId={"comingSoon"}
            title={"Coming soon..."}
            imageTarget={null}
            description={"Something really cool! 😉"}
            caseURL={null}
            video={null}
            live={null}
            techList={[
              { id: 1, content: "8thwall" },
              { id: 2, content: "A-Frame" },
              { id: 3, content: "WebXR" },
              { id: 4, content: "React.js" },
            ]}
            effectType={
              renderEffect[Math.floor(Math.random() * renderEffect.length)]
            }
          />
        </div>
      </div>

      {projectData.map((data) => {
        if (!data.isComing) {
          return (
            <div
              className={`row ${data.contentPos} animate__animated animate__fadeIn animate__delay-1s`}
            >
              <div className="col-md-12">
                <FeatureMedia
                  contentPos={data.contentPos}
                  opacity={1.0}
                  projectId={data.prefix}
                  title={data.title}
                  imageTarget={data.imageTarget}
                  description={data.description}
                  caseURL={data.case}
                  video={data.video}
                  live={data.live}
                  techList={data.techList}
                  effectType={
                    renderEffect[
                      Math.floor(Math.random() * renderEffect.length)
                    ]
                  }
                />
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default FeatureProjects;
